import { combineReducers } from 'redux'
import _ from 'lodash'

import * as preview from './preview'
import * as combinedExport from './combinedExport'
import * as combinedDownload from './combinedDownload'
import * as combinedList from './combinedList'
import * as combinedDelete from './combinedDelete'

const slices = {
  preview,
  combinedExport,
  combinedDownload,
  combinedList,
  combinedDelete
}

const invoiceTypes = _.mapValues(slices, (s) => s.slice.types)
const invoiceActions = Object.assign({}, ..._(slices).values().map('slice.actions').value())
const invoiceSagas = _(slices).values().map('slice.sagas').flatten().value()
const invoiceSelectors = Object.assign({}, ..._(slices).values().map('slice.selectors').value())
const reducers = Object.assign({}, ..._(slices).values().map('default').value())

export { invoiceTypes, invoiceActions, invoiceSagas, invoiceSelectors }

export default combineReducers(reducers)
